import { LeadForm } from "@/components/LeadForm";
import { CalendlyEmbed } from "@/components/CalendlyEmbed";

interface LeadFormSectionProps {
  title?: string;
  subtitle?: string;
  showCalendly?: boolean;
}

export const LeadFormSection = ({
  title = "Get Started",
  subtitle = "Tell us a bit about your business and what you need. We'll reply within 1 business day.",
  showCalendly = true,
}: LeadFormSectionProps) => {
  return (
    <section id="get-started" className="py-16 bg-accent/20">
      <div className="container px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4">{title}</h2>
            <p className="text-lg text-muted-foreground">{subtitle}</p>
          </div>

          <div className="bg-card rounded-2xl p-6 md:p-8 shadow-sm border">
            <LeadForm />
          </div>
        </div>
      </div>

      {showCalendly && (
        <>
          <div className="container px-4 md:px-6 py-10">
            <div className="max-w-md mx-auto text-center">
              <div className="flex items-center gap-4">
                <div className="flex-1 h-px bg-border" />
                <span className="text-muted-foreground font-medium">
                  Prefer to talk?
                </span>
                <div className="flex-1 h-px bg-border" />
              </div>
              <p className="text-sm text-muted-foreground mt-2">
                Schedule a call instead
              </p>
            </div>
          </div>
          <CalendlyEmbed variant="minimal" />
        </>
      )}
    </section>
  );
};
